import type { PartialParking } from '@repo/domain';
import type { ParkMarker } from '@repo/map';

import { hasParkingShapes } from '@features/parkingMap/utils/hasParkingShapes';

/**
 * The pins of the parkings. The pin of a parking drawn by its borders or entrance is hidden, not left out, so it
 * keeps its off-screen indicator.
 */
export const createParkingMarkers = (parkings: PartialParking[]): ParkMarker[] =>
  parkings.map((parking) => ({
    type: 'marker',
    parkingSlug: parking.slug,
    lotMode: parking.lotMode,
    hidden: hasParkingShapes(parking),
    position: {
      latitude: parking.address.coordinates.latitude,
      longitude: parking.address.coordinates.longitude,
    },
  }));
